import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Web3Context } from '../../context/Web3Context';
import useContract from '../../hooks/useContract';
import Loader from '../../components/Loader/Loader';
import './Register.css';

const Register = () => {
  const { account, isRegistered, connectWallet, isConnecting, showNotification } = useContext(Web3Context);
  const { register, loading, getUSDTBalance } = useContract();
  const [referrerId, setReferrerId] = useState('');
  const [balance, setBalance] = useState('0');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (isRegistered) {
      navigate('/dashboard');
    }
  }, [isRegistered, navigate]);

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) setReferrerId(ref);
  }, [searchParams]);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const bal = await getUSDTBalance();
        const { ethers } = require('ethers');
        setBalance(ethers.utils.formatEther(bal));
      } catch {}
    };
    if (account) fetchBalance();
  }, [account]);

  const handleRegister = async () => {
    if (!account) {
      showNotification('Please connect your wallet first.', 'warning');
      return;
    }
    const refId = parseInt(referrerId) || 100000;
    try {
      await register(refId);
      navigate('/dashboard');
    } catch {}
  };

  if (loading) return <Loader text="Registering" />;

  return (
    <div className="register-page">
      <div className="register-bg">
        <div className="reg-crystal-1"></div>
        <div className="reg-crystal-2"></div>
      </div>
      <div className="register-container">
        <div className="register-card">
          <div className="register-header">
            <div className="reg-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M19 8v6M22 11h-6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>Join UltraCapital</h2>
            <p>Start your journey with the Starter Package (10 USDT)</p>
          </div>

          <div className="register-body">
            <div className="form-group">
              <label>Referrer ID</label>
              <input
                type="number"
                placeholder="Enter referrer ID (optional)"
                value={referrerId}
                onChange={(e) => setReferrerId(e.target.value)}
                className="form-input"
              />
              <span className="form-hint">Leave empty to use default referrer</span>
            </div>

            <div className="register-info">
              <div className="info-row">
                <span>Package</span>
                <span className="info-value">Starter</span>
              </div>
              <div className="info-row">
                <span>Cost</span>
                <span className="info-value highlight">10 USDT</span>
              </div>
              <div className="info-row">
                <span>Your Balance</span>
                <span className="info-value">{parseFloat(balance).toFixed(2)} USDT</span>
              </div>
            </div>

            {!account ? (
              <button className="btn-primary btn-full" onClick={connectWallet} disabled={isConnecting}>
                {isConnecting ? 'Connecting...' : 'Connect Wallet First'}
              </button>
            ) : (
              <button className="btn-primary btn-full" onClick={handleRegister} disabled={loading}>
                {loading ? 'Processing...' : 'Register Now'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
